import React from 'react';
import './Events.less';
import { inject, observer } from 'mobx-react';
import { Row, Col, AppLocaleProvider } from 'sd-ui-components';
import AppLayout from '../AppLayout/AppLayout';
import BackBreadcrumb from '../Common/BackBreadcrumb';
import EventHeader from './EventHeader';
import EventsList from './EventsList';
import PageLoadLogger from '../../utils/PageLoadLogger';
import Notifications from '../../components/Notifications/Notifications';

const { FormattedMessage } = AppLocaleProvider;

@inject('ObservationsStore')
@inject('EventsStore')
@inject('ConfigStore')
@observer
class Events extends React.Component {
  pageLoadLogger = new PageLoadLogger('Events list');

  /**
   * When this component is mounted, load obsevations into the store if they haven't been loaded already.
   */
  componentDidMount() {
    const observationName = this.props.observationName;

    this.props.ObservationsStore.selectedObservation = observationName;

    // Look ma, no awaits.
    this.pageLoadLogger.addRequest(
      this.props.ObservationsStore.getAllObservations()
    );

    this.pageLoadLogger.addRequest(
      this.props.EventsStore.loadEventsForObservation(observationName)
    );

    this.pageLoadLogger.capture();
  }

  componentWillUnmount() {
    this.props.EventsStore.cancelLoadEventsForObservation();
  }

  render() {
    const { ObservationsStore, EventsStore } = this.props;

    return (
      <AppLayout>
        <BackBreadcrumb
          to="/drivingperformance"
          data-automation-id="sd-ui-driver-navigation-breadcrumb-driving-performance"
        >
          <FormattedMessage
            id="App.Navigation.BackToDriverPerformance"
            defaultMessage="Back to driver performance"
          />
        </BackBreadcrumb>
        <Row>
          <Col span={24}>
            <Notifications />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            {!ObservationsStore.loadingErrors.getAllObservations && (
              <EventHeader />
            )}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            {!EventsStore.loadingErrors.eventsList && <EventsList />}
          </Col>
        </Row>
      </AppLayout>
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/containers/Events/Events.jsx